'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import enviro from 'enviro';
import { EVENTS } from '../../../tracking/events';
import { List } from 'immutable';
import { RequestStatusPropType } from 'developer-docs-shared-components/lib/models/RequestStatus';
import { fetchEndpoints } from '../actions';
import { getEndpoints, getEndpointsStatus } from '../selectors';
import { getUsageTracker } from 'developer-docs-shared-components/tracking/usageTracker';
import FormattedMessage from 'I18n/components/FormattedMessage';
import LoadingHOC from 'developer-docs-shared-components/lib/hoc/LoadingHOC';
import UIDashboardPage from 'UIComponents/page/UIDashboardPage';
import UICardGrid from 'UIComponents/card/UICardGrid';
import UICardHeader from 'UIComponents/card/UICardHeader';
import UICardSection from 'UIComponents/card/UICardSection';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UIHeader from 'UIComponents/layout/UIHeader';
import UITable from 'UIComponents/table/UITable';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import UIInputStaticLabel from 'UIComponents/input/UIInputStaticLabel';
import UITextInput from 'UIComponents/input/UITextInput';
import UITag from 'UIComponents/tag/UITag';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
const TAG_COLORS = {
  DEVELOPER_PREVIEW: 'calypso',
  LATEST: 'thunderdome',
  STABLE: 'oz',
  DEPRECATED: 'sorbet',
  ARCHIVED: 'candy-apple'
};

const HomePageCard = ({
  i18nKey,
  children
}) => /*#__PURE__*/_jsxs(UICardWrapper, {
  children: [/*#__PURE__*/_jsx(UICardHeader, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${i18nKey}.header`
    })
  }), children]
});

const getPath = specUrl => {
  const match = specUrl.match(/^https:\/\/api.hubspot(?:qa)?.com\/api-catalog-public\/(.*)$/);
  return match && match.length > 1 ? match[1] : null;
};

class EndpointsList extends Component {
  constructor(props) {
    super(props);

    this.updateCustomUrl = ({
      target: {
        value
      }
    }) => {
      this.setState({
        customUrl: value
      });
    };

    this.updateCustomInternalUrl = ({
      target: {
        value
      }
    }) => {
      if (value.startsWith(this.internalApiPrefix)) {
        value = value.slice(this.internalApiPrefix.length);
      }

      this.setState({
        customInternalUrl: value
      });
    };

    this.state = {
      customUrl: 'https://petstore.swagger.io/v2/swagger.json',
      customInternalUrl: ''
    };
    this.isQa = enviro.isQa();
    this.isLocal = !enviro.deployed();
    this.internalApiPrefix = `https://api.hubspot${this.isQa ? 'qa' : ''}.com/`;
    this.tracker = getUsageTracker();
  }

  componentDidMount() {
    this.tracker.track(EVENTS.PAGEVIEW, {
      screen: 'home'
    });
    this.props.fetchEndpoints();
  }

  renderDynamicEndpoints() {
    const {
      endpoints
    } = this.props;
    return /*#__PURE__*/_jsxs(UITable, {
      flush: true,
      condensed: true,
      hover: false,
      children: [/*#__PURE__*/_jsx("thead", {
        children: /*#__PURE__*/_jsxs("tr", {
          children: [/*#__PURE__*/_jsx("th", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "endpoints.api"
            })
          }), /*#__PURE__*/_jsx("th", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "endpoints.feature"
            })
          }), /*#__PURE__*/_jsx("th", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "endpoints.stages.title"
            })
          })]
        })
      }), /*#__PURE__*/_jsx("tbody", {
        children: endpoints.toJS().map(group => {
          const features = Object.keys(group.features).sort();
          return features.map((key, ind) => /*#__PURE__*/_jsxs("tr", {
            children: [ind === 0 && /*#__PURE__*/_jsx("td", {
              rowSpan: features.length,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `endpoints.features.${group.name}`
              })
            }), /*#__PURE__*/_jsx("td", {
              children: /*#__PURE__*/_jsx(UIRouterLink, {
                to: `/api?spec=${getPath(group.features[key].openAPI)}`,
                "data-test-id": "endpoint-link",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: `endpoints.names.${key.toLowerCase().replace(' ', '-')}`,
                  options: {
                    defaultValue: key
                  }
                })
              })
            }), /*#__PURE__*/_jsx("td", {
              children: /*#__PURE__*/_jsx(UITag, {
                use: TAG_COLORS[group.features[key].stage] || 'default',
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: `endpoints.stages.${group.features[key].stage}`,
                  options: {
                    defaultValue: group.features[key].stage
                  }
                })
              })
            })]
          }, key));
        })
      })]
    });
  }

  render() {
    const {
      endpointsStatus
    } = this.props; // TODO: When do we want to render this?

    const displayCustomSpec = false;
    return /*#__PURE__*/_jsx(LoadingHOC, {
      statuses: [endpointsStatus],
      error: {
        title: 'home.viewEndpoints.error.title',
        body: 'home.viewEndpoints.error.body'
      },
      children: endpointsStatus.succeeded && /*#__PURE__*/_jsx(NavMarker, {
        name: "INDEX_LOAD",
        children: /*#__PURE__*/_jsx(UIDashboardPage, {
          headerComponent: /*#__PURE__*/_jsx(UIHeader, {
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.htmlTitle"
            })
          }),
          "data-test-id": "home-page",
          children: /*#__PURE__*/_jsxs(UICardGrid, {
            columns: 2,
            children: [/*#__PURE__*/_jsx(HomePageCard, {
              i18nKey: "home.viewEndpoints",
              children: this.renderDynamicEndpoints()
            }), displayCustomSpec && /*#__PURE__*/_jsxs(HomePageCard, {
              i18nKey: "home.custom",
              children: [/*#__PURE__*/_jsx(UICardSection, {
                children: /*#__PURE__*/_jsx(UIFormControl, {
                  label: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "home.custom.label"
                  }),
                  help: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "home.custom.instructions"
                  }),
                  children: /*#__PURE__*/_jsx(UIMediaObject, {
                    itemRight: /*#__PURE__*/_jsx(UIRouterButton, {
                      use: "tertiary-light",
                      to: `/custom?url=${encodeURIComponent(this.state.customUrl)}`,
                      children: /*#__PURE__*/_jsx(FormattedMessage, {
                        message: "home.custom.view"
                      })
                    }),
                    children: /*#__PURE__*/_jsx(UITextInput, {
                      onChange: this.updateCustomUrl,
                      value: this.state.customUrl
                    })
                  })
                })
              }), (this.isQa || this.isLocal) && /*#__PURE__*/_jsx(UICardSection, {
                children: /*#__PURE__*/_jsx(UIFormControl, {
                  label: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "home.customInternal.label"
                  }),
                  help: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "home.customInternal.instructions"
                  }),
                  children: /*#__PURE__*/_jsx(UIMediaObject, {
                    itemRight: /*#__PURE__*/_jsx(UIRouterButton, {
                      use: "tertiary-light",
                      to: `/custom?internal=true&url=${encodeURIComponent(this.state.customInternalUrl)}`,
                      children: /*#__PURE__*/_jsx(FormattedMessage, {
                        message: "home.customInternal.view"
                      })
                    }),
                    children: /*#__PURE__*/_jsx(UIInputStaticLabel, {
                      text: this.internalApiPrefix,
                      children: /*#__PURE__*/_jsx(UITextInput, {
                        onChange: this.updateCustomInternalUrl,
                        value: this.state.customInternalUrl
                      })
                    })
                  })
                })
              })]
            })]
          })
        })
      })
    });
  }

}

EndpointsList.propTypes = {
  fetchEndpoints: PropTypes.func.isRequired,
  endpointsStatus: RequestStatusPropType.isRequired,
  endpoints: PropTypes.instanceOf(List)
};

const mapStateToProps = state => {
  return {
    endpoints: getEndpoints(state),
    endpointsStatus: getEndpointsStatus(state)
  };
};

const mapDispatchToProps = {
  fetchEndpoints
};
export default connect(mapStateToProps, mapDispatchToProps)(EndpointsList);